export const ROOT = 'jobTop';

export const FETCH_JOB_TOP_REQUEST = `${ROOT}/FETCH_JOB_TOP_REQUEST`;
export const FETCH_JOB_TOP_FAILURE = `${ROOT}/FETCH_JOB_TOP_FAILURE`;
export const FETCH_JOB_TOP_SUCCESS = `${ROOT}/FETCH_JOB_TOP_SUCCESS`;